module.exports = {
  CARDHOLDER_TYPE: {
    PRIMARY: 'PRIMARY',
    ADD_ON: 'ADD_ON'
  }
};
